import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaOperacion } from '../_operacion.js';

/**
 * La reposición de la caja menor, dentro del grupo `_operacion`.
 *
 * VA ACÁ Y NO EN `_contabilidad` PORQUE QUIEN REPONE ES EL JEFE DE OPERARIOS, que es de nivel 1
 * y aquel grupo deja fuera. `app.reponer_caja_menor` admite jefe de operarios y administrador
 * desde `20260729101500_reponer_solo_jefe_operarios.sql`, y su rechazo es quien decide: la ruta
 * no vuelve a escribir la lista de roles.
 *
 * LA PANTALLA LLEVABA DESDE LA FASE 4 CONSTRUIDA, PROBADA Y SIN RUTA, y ninguna prueba lo veía
 * porque `arbol.test.ts` solo comprueba que toda ruta declarada esté montada. Adjudicación 191.
 */
export const rutaCajaMenor = createRoute({
  getParentRoute: () => rutaOperacion,
  path: '/caja-menor',
  component: lazyRouteComponent(() => import('./caja-menor-pantalla.js'), 'RutaCajaMenor'),
});
